import React, { useState, useEffect, useCallback } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Button,
    Typography,
    Divider,
    Box,
} from '@mui/material';
import { GroupApi, UserApi } from '../../apis';
import { useFormik } from 'formik';
import MultiSelect from '../multi-select/MultiSelect';


function AddUserDialog({ open, handleClose, groupId }) {
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [userOptions, setUserOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const formik = useFormik({
        initialValues: {
            userIds: selectedUsers,
            groupId: groupId,
        },
        onSubmit: async (values) => {
            try {
                const transformedUserIds = values.userIds.map(user => user.value);

                const payload = {
                    userIds: transformedUserIds,
                    groupId: values.groupId
                };

                const response = await GroupApi.addGroupUser(payload);
                handleClose(); // Close dialog on success
            } catch (error) {
                console.error('Error creating project:', error);
            } finally {
                setLoading(false);
            }
        },
    });
    const fetchUsers = async () => {
        try {
            const res = await UserApi.getAllUsers();
            const options = res.data.data.users.map((user) => ({
                value: user.id,
                label: user.name,
            }));
            setUserOptions(options);
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };
    const fetchGroupUsers = async () => {
        try {
            const res = await GroupApi.getGroupUserById(groupId);
            // Check if we have the correct data structure
            if (res.data.data && Array.isArray(res.data.data)) {
                const groupUsers = res.data.data.map((data) => ({
                    value: data.user.id,
                    label: data.user.name,
                }));
                setSelectedUsers(groupUsers);
                formik.setFieldValue('userIds', groupUsers);
            } else {
            }
        } catch (error) {
            console.error('Error fetching group users:', error);
        }
    }

    useEffect(() => {
        if (groupId) {
            formik.setFieldValue('groupId', groupId);
        }
    }, [groupId, open]);
    useEffect(() => {
        if (open) fetchUsers();
    }, [open]);
    useEffect(() => {
        if (open) fetchGroupUsers();
    }, [open, groupId]);

    useEffect(() => {

    }, [selectedUsers]);
    return (
        <Dialog open={open} onClose={handleClose} fullWidth    >
            <DialogTitle>
                <Typography variant="h6" color="primary" fontWeight="bold" ml={1}>
                    Add Users in Group
                </Typography>
            </DialogTitle>
            <Divider sx={{ width: "90%", mx: "auto" }} />
            <DialogContent sx={{
                overflowY: "auto",
                minHeight: "300px",
            }}                 >
                <Box  component="form"
                    p={2}
                >
                    <MultiSelect
                        formik={formik}
                        name="userIds"
                        options={userOptions}
                        value={formik.values.userIds}
                        onchange={(selected) =>
                            formik.setFieldValue('userIds', selected || [])
                        }
                        isColored={true}
                        label="Users"
                        defaultLabel="Select Users"
                        required={true}
                    />
                    
                </Box>

                <Box display="flex" justifyContent="end" mt={2}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={formik.handleSubmit}
                        disabled={loading}
                    >
                        Add Users
                    </Button>
                    </Box>
            </DialogContent>
        </Dialog>
    );
}

export default AddUserDialog;
